// @generated by protoc-gen-es v2.9.0 with parameter "target=dts+js,js_import_style=legacy_commonjs"
// @generated from file stailer_service_specification/marketing/tracking/v1/tracking.proto (package stailer_service_specification.marketing.tracking.v1, syntax proto3)
/* eslint-disable */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });

const { fileDesc, messageDesc } = require("@bufbuild/protobuf/codegenv2");
const { file_description_support_v1_field_description } = require("../../../../description_support/v1/field_description_pb");

/**
 * Describes the file stailer_service_specification/marketing/tracking/v1/tracking.proto.
 */
const file_stailer_service_specification_marketing_tracking_v1_tracking = /*@__PURE__*/
  fileDesc("CkJzdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi9tYXJrZXRpbmcvdHJhY2tpbmcvdjEvdHJhY2tpbmcucHJvdG8SM3N0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLm1hcmtldGluZy50cmFja2luZy52MSLCAQoQQWRqdXN0RXZlbnRUb2tlbhJRCgpldmVudF9uYW1lGAEgASgJQj2SghkeQWRqdXN0IEV2ZW5044Gu5ZCN5YmN44Gn44GZ44CCqoIZD+OCpOODmeODs+ODiOWQjbiCGQPAghkBElsKBXRva2VuGAIgASgJQkySghkkQWRqdXN0IEV2ZW5044Gu44OI44O844Kv44Oz44Gn44GZ44CCqoIZGOOCpOODmeODs+ODiOODiOODvOOCr+ODs7iCGQPAghkBIrgCChFBZGp1c3RFbnZpcm9ubWVudBJlCglhcHBfdG9rZW4YASABKAlCUpKCGSdBZGp1c3Tjga7jgqLjg5fjg6rjg4jjg7zjgq/jg7PjgafjgZnjgIKqghkbQWRqdXN044Ki44OX44Oq44OI44O844Kv44OzuIIZA8CCGQESuwEKDGV2ZW50X3Rva2VucxgCIAMoCzJFLnN0YWlsZXJfc2VydmljZV9zcGVjaWZpY2F0aW9uLm1hcmtldGluZy50cmFja2luZy52MS5BZGp1c3RFdmVudFRva2VuQl6SghkqQWRqdXN0IEV2ZW5044Gu44OI44O844Kv44Oz5LiA6Kan44Gn44GZ44CCqoIZJEFkanVzdOOCpOODmeODs+ODiOODiOODvOOCr+ODs+S4gOimp7iCGQPAghkBIt8CCgZBZGp1c3QSqAEKCnByb2R1Y3Rpb24YASABKAsyRi5zdGFpbGVyX3NlcnZpY2Vfc3BlY2lmaWNhdGlvbi5tYXJrZXRpbmcudHJhY2tpbmcudjEuQWRqdXN0RW52aXJvbm1lbnRCTJKCGSTmnKznlarnkrDlooPjga5BZGp1c3ToqK3lrprjgafjgZnjgIKqghkY5pys55Wq55Kw5aKDQWRqdXN06Kit5a6auIIZA8CCGQESqQEKC2RldmVsb3BtZW50GAIgASgLMkYuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ubWFya2V0aW5nLnRyYWNraW5nLnYxLkFkanVzdEVudmlyb25tZW50QkySghkk6ZaL55m655Kw5aKD44GuQWRqdXN06Kit5a6a44Gn44GZ44CCqoIZGOmWi+eZuueSsOWig0FkanVzdOioreWumriCGQPAghkBIqMBCghUcmFja2luZxKWAQoGYWRqdXN0GAEgASgLMjsuc3RhaWxlcl9zZXJ2aWNlX3NwZWNpZmljYXRpb24ubWFya2V0aW5nLnRyYWNraW5nLnYxLkFkanVzdEJJkoIZJ0FkanVzdOioiOa4rOOBq+mWouOBmeOCi+ioreWumuOBp+OBmeOAgqqCGRJBZGp1c3ToqIjmuKzoqK3lrpq4ghkDwIIZAWIGcHJvdG8z", [file_description_support_v1_field_description]);

/**
 * Describes the message stailer_service_specification.marketing.tracking.v1.AdjustEventToken.
 * Use `create(AdjustEventTokenSchema)` to create a new message.
 */
const AdjustEventTokenSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_tracking_v1_tracking, 0);

/**
 * Describes the message stailer_service_specification.marketing.tracking.v1.AdjustEnvironment.
 * Use `create(AdjustEnvironmentSchema)` to create a new message.
 */
const AdjustEnvironmentSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_tracking_v1_tracking, 1);

/**
 * Describes the message stailer_service_specification.marketing.tracking.v1.Adjust.
 * Use `create(AdjustSchema)` to create a new message.
 */
const AdjustSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_tracking_v1_tracking, 2);

/**
 * Describes the message stailer_service_specification.marketing.tracking.v1.Tracking.
 * Use `create(TrackingSchema)` to create a new message.
 */
const TrackingSchema = /*@__PURE__*/
  messageDesc(file_stailer_service_specification_marketing_tracking_v1_tracking, 3);


exports.file_stailer_service_specification_marketing_tracking_v1_tracking = file_stailer_service_specification_marketing_tracking_v1_tracking;
exports.AdjustEventTokenSchema = AdjustEventTokenSchema;
exports.AdjustEnvironmentSchema = AdjustEnvironmentSchema;
exports.AdjustSchema = AdjustSchema;
exports.TrackingSchema = TrackingSchema;
